import {SmartComponent} from "smart-component-js";

class MapComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.mapElement = this.element.querySelector(".map-component__map");
        console.log("Elemento della mappa trovato:", this.mapElement);
        this.searchForm = this.element.querySelector(".map-component__search-form");
        this.resultsContainer = this.element.querySelector(".results-list");
        this.counterResults = this.element.querySelector(".counter-results");
        this.divider = this.element.querySelector(".divider");
        this.detailsContainer = this.createDetailsContainer();
        this.map = null;
        this.markers = [];
        this.searchLocation = null;
        this.hasSearched = false;
        this.markerCluster = null;
        this.productId = this.element.dataset.id;
        this.categoryId = this.element.dataset.id;
        this.init();
    }

    init() {
        this.initMap();
        this.setupSearchHandler();
        this.setupFindAgencyButton();
        this.toggleResetButton();
    }

    initMap() {
        this.map = new google.maps.Map(this.mapElement, {
            center: {lat: 41.8719, lng: 12.5674},
            zoom: 6,
            mapId: 'DEMO_APP_ID',
            disableDefaultUI: true,
            zoomControl: false
        });

        google.maps.event.addListener(this.map, 'zoom_changed', () => {
            this.handleMapChange()
        });

        google.maps.event.addListener(this.map, 'dragend', () => {
            this.handleMapChange()
        });

        this.counterResults.style.visibility = "hidden";
        this.displayInitialPoints();
    }

    handleMapChange = this.debounce(() => {
        if (this.hasSearched) {
            this.fetchNearbyAgencies();
        } else {
            this.updateVisibleMarkers();
        }
    }, 300);

    debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    updateVisibleMarkers() {
        this.visibleMarkers = [];

        const bounds = this.map.getBounds();
        if (!bounds) {
            console.warn("I limiti della mappa non sono ancora disponibili.");
            return;
        }
        this.markers.forEach((marker) => {
            if (bounds.contains(marker.getPosition())) {
                this.visibleMarkers.push(marker);
            }
        });

        console.log("Marker visibili aggiornati:", this.visibleMarkers.length);
    }

    displayInitialPoints() {
        this.clearMarkers();
        //   const apiUrl = `https://www.hdiassicurazioni.it/api/jsonws/hdi.geopoi/get-by-area/minLatitudine/36.0/maxLatitudine/47.0/minLongitudine/6.0/maxLongitudine/19.0/listaType/1,4?p_auth=BqQlCePb`;
        youserxp.ajax(`/api/1.0/hdi-assicurazioni/agencies/36.0/47.0/6.0/19.0`, {
            method: 'GET',
            auth: true
        }).then(
            (data) => {
                let agenciesDistance = data.body;
                this.agencyList = agenciesDistance


                //  fetch(apiUrl)
                //      .then(response => response.json())
                //      .then(agencies => {
                if (agenciesDistance.length === 0) {
                    console.error("Nessun punto trovato inizialmente.");
                    return;
                }

                const updateVisibleMarkers = () => {
                    const bounds = this.map.getBounds();
                    if (!bounds) {
                        console.warn("I limiti della mappa non sono ancora disponibili.");
                        return;
                    }
                    const visibleMarkers = agenciesDistance.filter(agencyD => {
                        const agencyLocation = new google.maps.LatLng(agencyD.agencyDTO.latitude, agencyD.agencyDTO.longitude);
                        return bounds.contains(agencyLocation);
                    }).map(agencyD => {
                        const agencyLocation = new google.maps.LatLng(agencyD.agencyDTO.latitude, agencyD.agencyDTO.longitude);
                        return this.createMarker(agencyLocation, agencyD.agencyDTO.descrizionerui, agencyD.agencyDTO.typeName, agencyD.agencyDTO);
                    });

                    this.clearMarkers();
                    this.markers = visibleMarkers;
                    this.applyMarkerClustererOnStart(visibleMarkers);
                };

                updateVisibleMarkers();
                this.map.addListener('bounds_changed', updateVisibleMarkers);
            })
            .catch(error => {
                console.error("Errore nella richiesta API:", error);
                this.resultsContainer.innerHTML = "<div class='error-message'>Si è verificato un errore durante il caricamento dei punti iniziali.</div>";
            });
    }


    applyMarkerClustererOnStart(markersArray) {
        const visibleMarkers = this.markers.filter(marker => this.map.getBounds().contains(marker.getPosition()));
        if (!visibleMarkers.length) return;
        if (typeof MarkerClusterer === "undefined") {
            console.error("MarkerClusterer non è disponibile. Assicurati di aver importato correttamente la libreria.");
            return;
        }

        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
        }

        if (!visibleMarkers.length) {
            console.error("Nessun marker da visualizzare.");
            return;
        }

        const renderer = {
            render: ({count, position}) => {
                const circleIcon = {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: '#006729',
                    fillOpacity: 1,
                    scale: 14,
                    strokeColor: '#FFFFFF',
                    strokeWeight: 0,
                };
                return new google.maps.Marker({
                    label: {text: String(count), color: "white", fontSize: "16px"},
                    position,
                    icon: circleIcon,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });
            },
        };

        const map = this.map;
        if (!map) {
            console.error("La mappa non è inizializzata.");
            return;
        }

        this.markerCluster = new MarkerClusterer({
            renderer,
            map,
            markers: visibleMarkers
        });
    }

    applyMarkerClusterer() {
        if (typeof MarkerClusterer === "undefined") {
            console.error("MarkerClusterer non è disponibile. Assicurati di aver importato correttamente la libreria.");
            return;
        }

        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
        }

        if (!this.markers.length) {
            console.error("Nessun marker da visualizzare.");
            return;
        }

        const renderer = {
            render: ({count, position}) => {
                const circleIcon = {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: '#006729',
                    fillOpacity: 1,
                    scale: 14,
                    strokeColor: '#FFFFFF',
                    strokeWeight: 0,
                };
                return new google.maps.Marker({
                    label: {text: String(count), color: "white", fontSize: "16px"},
                    position,
                    icon: circleIcon,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                });
            },
        };

        const map = this.map;
        if (!map) {
            console.error("La mappa non è inizializzata.");
            return;
        }

        this.markerCluster = new MarkerClusterer({
            renderer,
            map,
            markers: this.markers
        });
    }

    createMarker(location, title, typeName, agency) {
        let customIcon = {};
        if (typeName === "Agency_HDI") {
            customIcon = {
                url: '/fe-web/img/hdiassicurazioni/icons/marker-full.svg',
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(15, 15),
            };
        } else if (typeName === "Agency_affiliated") {
            customIcon = {
                url: '/fe-web/img/hdiassicurazioni/icons/marker-white.svg',
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(15, 15),
            };
        }

        const marker = new google.maps.Marker({
            position: location,
            title: title,
            icon: customIcon,
        });

        marker.addListener('click', () => {
            //  const city = agency.citta || "Città non disponibile";
            //  const street = agency.indirizzo || "Indirizzo non disponibile";
            this.handleDetailsClick(agency, agency.address, true);
        });

        this.markers.push(marker);

        return marker;
    }

    addMarker(location, title, typeName, agency) {
        const customIcon = document.createElement('img');
        if (typeName === "Agency_HDI") {
            customIcon.src = '/fe-web/img/hdiassicurazioni/icons/marker-full.svg'
        } else if (typeName === "Agency_affiliated") {
            customIcon.src = '/fe-web/img/hdiassicurazioni/icons/marker-white.svg'
        }

        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: location,
            map: this.map,
            title,
            content: customIcon
        });

        marker.addListener("click", () => {
            //   const city = agency.citta || "Città non disponibile";
            //   const street = agency.indirizzo || "Indirizzo non disponibile";
            this.handleDetailsClick(agency, agency.address, false);
        });

        this.markers.push(marker);
    }

    toggleResetButton(e) {
        const resetButton = this.searchForm?.querySelector(".map-component__reset");
        if (!resetButton) return;
        if (e?.target?.value == null || e.target.value.trim() === "") {
            resetButton.style.display = "none"; // Nasconde il pulsante
        } else {
            resetButton.style.display = "flex"; // Mostra il pulsante
        }
    }

    setupSearchHandler() {
        if (!this.searchForm || !this.resultsContainer) return;
        const inputAddress = this.searchForm.querySelector("input[name='address']");
        inputAddress.addEventListener("input", this.toggleResetButton.bind(this));
        const searchButton = this.searchForm.querySelector(".search-button");

        const autocomplete = new google.maps.places.Autocomplete(inputAddress, {
            //   types: ["address"],
            componentRestrictions: {country: "IT"},
        });

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (!place.geometry) {
                console.error("Indirizzo non valido");
                return;
            }
            this.searchLocation = place.geometry.location;
            this.hasSearched = true;
            this.map.setCenter(this.searchLocation);
            this.map.setZoom(Math.min(this.map.getZoom(), 14));
            searchButton.click();
        });

        this.searchForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const address = inputAddress.value;
            const geocoder = new google.maps.Geocoder();

            geocoder.geocode({address}, (results, status) => {
                if (status === "OK") {
                    const resultLocation = results[0].geometry.location;
                    const bounds = results[0].geometry.viewport;

                    this.clearMarkers();
                    this.resultsContainer.innerHTML = "";

                    this.map.fitBounds(bounds);
                    this.map.setZoom(Math.min(this.map.getZoom(), 14));

                    this.searchLocation = resultLocation;
                    this.hasSearched = true;

                    this.fetchNearbyAgencies();
                } else {
                    console.error("Geocoding fallito:", status);
                    this.resultsContainer.innerHTML = "<div class='error-message'>Indirizzo non trovato. Per favore riprova.</div>";
                }
            });
        });
        const resetButton = this.searchForm.querySelector(".map-component__reset");
        resetButton?.addEventListener("click", () => {
            inputAddress.value = "";
            this.searchForm.querySelector(".map-component__reset").style.display = "none";
        });
    }

    setupFindAgencyButton() {
        this.clearMarkers();
        const findAgencyButton = this.element.querySelector(".map-component__find-agency");
        const inputAddress = this.searchForm.querySelector("input[name='address']");
        const searchButton = this.searchForm.querySelector(".search-button");
        const geocoder = new google.maps.Geocoder();
        const loader = document.getElementById("loader");

        if (!findAgencyButton) return;

        findAgencyButton.addEventListener("click", () => {
            if (navigator.geolocation) {
                loader.style.display = "block";
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const {latitude, longitude} = position.coords;
                        const userLocation = new google.maps.LatLng(latitude, longitude);

                        geocoder.geocode({location: userLocation}, (results, status) => {
                            loader.style.display = "none";
                            if (status === "OK" && results[0]) {
                                const address = results[0].formatted_address;
                                inputAddress.value = address;

                                this.map.setCenter(userLocation);
                                this.map.setZoom(Math.min(this.map.getZoom(), 14));

                                searchButton.click();
                            } else {
                                loader.style.display = "none";
                                console.error("Geocoding fallito:", status);
                                alert("Impossibile ottenere l'indirizzo dalla tua posizione.");
                            }
                        });
                    },
                    (error) => {
                        console.error("Errore nella geolocalizzazione:", error);
                        alert("Impossibile accedere alla posizione. Per favore, abilita la geolocalizzazione nel tuo browser.");
                    }
                );
            } else {
                alert("La geolocalizzazione non è supportata dal tuo browser.");
            }
        });
    }


    fetchNearbyAgencies(isInitialLoad = false) {
        this.detailsContainer.classList.add("hidden");
        this.detailsContainer.classList.remove("slide-in", "slide-out");

        this.resultsContainer.classList.remove("hidden", "slide-out");
        this.resultsContainer.classList.add("slide-in");

        this.counterResults.classList.remove("hidden");
        this.divider.classList.remove("hidden");

        const divider = document.querySelector('.divider');
        divider.classList.remove('hidden');

        if (!this.hasSearched && !isInitialLoad) return;

        const currentZoom = this.map.getZoom();
        const bounds = this.map.getBounds();
        if (!bounds && !isInitialLoad) return;

        let minLat, maxLat, minLng, maxLng;

        if (!isInitialLoad) {
            const ne = bounds.getNorthEast();
            const sw = bounds.getSouthWest();
            minLat = sw.lat();
            maxLat = ne.lat();
            minLng = sw.lng();
            maxLng = ne.lng();
        } else {
            minLat = 36.0;
            maxLat = 47.0;
            minLng = 6.0;
            maxLng = 19.0;
        }

        //    const apiUrl = `https://www.hdiassicurazioni.it/api/jsonws/hdi.geopoi/get-by-area/minLatitudine/${minLat}/maxLatitudine/${maxLat}/minLongitudine/${minLng}/maxLongitudine/${maxLng}/listaType/1,4?p_auth=BqQlCePb`;

        this.clearMarkers();
        this.resultsContainer.innerHTML = "";

        if (!isInitialLoad) {
            this.counterResults.style.visibility = "hidden";
        }

        youserxp.ajax(`/api/1.0/hdi-assicurazioni/agencies/${minLat}/${maxLat}/${minLng}/${maxLng}`, {
            method: 'GET',
            auth: true
        }).then(
            (data) => {
                let agenciesDistance = data.body;


                //     fetch(apiUrl)
                //         .then(response => response.json())
                //         .then(agencies => {
                if (agenciesDistance.length === 0) {
                    this.handleNoResults();
                    return;
                }

                const geocoder = new google.maps.Geocoder();
                const agenciesWithDistance = [];

                console.log('agenciesDistance found:' + agenciesDistance.length);
                agenciesDistance.forEach(agencyD => {
                    const agencyLocation = new google.maps.LatLng(agencyD.agencyDTO.latitude, agencyD.agencyDTO.longitude);

                    if (bounds && bounds.contains(agencyLocation)) {
                        const distance = google.maps.geometry.spherical.computeDistanceBetween(this.searchLocation, agencyLocation);
                        agenciesWithDistance.push({
                            ...agencyD.agencyDTO,
                            distance,
                            location: agencyLocation,
                        });
                    } else if (isInitialLoad) {
                        agenciesWithDistance.push({
                            ...agencyD.agencyDTO,
                            location: agencyLocation,
                        });
                    }
                });

                agenciesWithDistance
                    .filter(a => typeof a.distance === "number" && !isNaN(a.distance))
                    .sort((a, b) => a.distance - b.distance);

                console.log('agenciesWithDistance found:' + agenciesWithDistance.length);

                agenciesWithDistance.forEach(agency => {
                    const agencyLocation = agency.location;

                    this.addMarker(agencyLocation, agency.descrizionerui, agency.typeName, agency);

                    if (!isInitialLoad) {
                        const distanceKm = (agency.distance / 1000).toFixed(2);

                        geocoder.geocode({location: agencyLocation}, (results, status) => {
                        });
                    }
                });

                agenciesWithDistance.forEach(agency => {
                    const distanceKm = (agency.distance / 1000).toFixed(2);

                    const existingAgency = Array.from(this.resultsContainer.children).find(
                        child => child.dataset.codiceudv === agency.codiceudv
                    );

                    if (!existingAgency) {
                        const agencyElement = `
                                <div class="agency-detail" data-codiceudv="${agency.codiceudv}">
                                    <div class="agency-top">
                                        <div class="agency-name ${agency.typeName === "Agency_HDI" ? "agenzia" : "affiliata"}">
                                            <strong>${agency.typeName === "Agency_HDI" ? "Agenzia HDI" : "Agenzia affiliata"}</strong>
                                        </div>
                                        <div class="agency-distance">${distanceKm} km da te</div>
                                    </div>
                                    <div class="agency-address">
                                        <div class="agency-address-city"><strong>${agency.name}</strong></div> 
                                        <div class="agency-address-street">${agency.address}
                                            <div class="agency-details"></div>
                                        </div>                          
                                    </div>
                                </div>
                                `;
                        this.resultsContainer.insertAdjacentHTML('beforeend', agencyElement);
                        const detailsAgency = this.resultsContainer.querySelector(`.agency-detail[data-codiceudv="${agency.codiceudv}"]`);

                        detailsAgency.addEventListener("click", () => {
                            this.handleDetailsClick(agency, agency.address, false);
                        });
                    }
                });

                this.applyMarkerClusterer();

                if (!isInitialLoad) {
                    this.counterResults.textContent = `${agenciesWithDistance.length} agenzie trovate`;
                    this.counterResults.style.visibility = "visible";
                }
            },
            (err) => {
                console.error("Errore nella richiesta API:", error);
                this.resultsContainer.innerHTML = `<div class="error-message">Si è verificato un errore durante la ricerca delle agenzie.</div>`;
            }
        );
    }


    createDetailsContainer() {
        const detailsContainer = document.createElement("div");
        detailsContainer.classList.add("details-container", "hidden");

        this.searchForm.appendChild(detailsContainer);
        return detailsContainer;
    }

    getQueryParam(param) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    handleDetailsClick(agency, addressA, onCreate) {
        const agencyLocation = new google.maps.LatLng(agency.latitude, agency.longitude);
        this.map.setCenter(agencyLocation);
        this.map.setZoom(15);

        this.resultsContainer.classList.add("slide-out");
        setTimeout(() => {
            this.resultsContainer.classList.add("hidden");
            this.detailsContainer.classList.remove("hidden", "slide-out");
            this.detailsContainer.classList.add("slide-in");
            this.counterResults.classList.add("hidden");
            this.divider.classList.add("hidden");

            const date = this.formatDate(agency.datarui);

            let backButtonHTML = !onCreate ? '<div class="back-button"><strong>Torna indietro</strong></div>' : '';
            let divider = !onCreate ? '<div class="divider-details"></div>' : '';

            const productId = this.productId ? this.productId : this.getQueryParam("productId");
            const categoryId = this.categoryId ? this.categoryId : this.getQueryParam("categoryId");


            this.detailsContainer.innerHTML = `
            <div class="details-content">
            ${backButtonHTML}
                ${divider}
                <div class="agency-address-details">
                    <div class="agency-left-details">
                        <div class="agency-top">
                            <div class="agency-name ${agency.typeName === "Agency_HDI" ? "agenzia" : "affiliata"}">
                                <strong>${agency.typeName === "Agency_HDI" ? "Agenzia HDI" : "Agenzia affiliata"}</strong>
                            </div>
                        </div>
                        <div class="agency-address">
                        <h5 class="agency-title-name">${agency.name}</h5>
                          <!--  <h5 class="agency-details-city"><strong>city</strong></h5> -->
                            <div class="agency-address-street">${addressA}</div>
                        </div>
                    </div>
                    <div class="agency-right-details">
                        <a href="${GENERIC_TAGS.contactUsLink}?agencyId=${agency.id}${productId ? `&productId=${productId}` : ''}${categoryId ? `&categoryId=${categoryId}` : ''}" class="contact-us">Contatta</a>
                    </div>
                </div>
                
                ${(agency.phone || agency.email || agency.pec) ? `
                    <div class="divider-details"></div>
                    <div class="agency-contacts">
                        <p class="green" style="font-size: 18px"><strong>Contatti</strong></p>
                        ${agency.phone ? `<b class="agency-details-phone">${agency.phone}</b>` : ''}
                        ${agency.email ? `<b class="agency-details-mail">${agency.email}</b>` : ''}
                        ${agency.pec ? `<b class="agency-details-pec">${agency.pec}</b>` : ''}
                    </div>
                ` : ''}
                <div class="divider-details"></div>
                <p class="green agente-generale"><strong>Agente Generale</strong></p>
                 ${agency.descrizionerui ? `<p>${agency.descrizionerui}</p>` : ''}
                 ${(agency.codicerui && date) ? `<p>${agency.codicerui} del ${date}</p>` : `<p>${agency.codicerui}</p>`}
                 
                 <div class="divider-details"></div>
                 <p class="green agente-generale"><strong>${agency.typeName === "Agency_HDI" ? "Subagenzia affiliata" : "Agenzia HDI di riferimento"}</strong></p>
                 <div> ${agency.typeName === "Agency_HDI" && this.agencyAffiliatedInfo.length >= 1 ? this.agencyAffiliatedInfo(agency.codiceudv): this.agencyParentInfo(agency.codiceudvparent)}</div>                          

            </div>
        `;

            const backButton = this.detailsContainer.querySelector(".back-button");

            if (backButton && onCreate) {
                backButton.classList.add("hidden");
            } else {
                console.error("Back button non trovato!");
            }

            this.detailsContainer.querySelector(".back-button").addEventListener("click", () => {
                this.resultsContainer.classList.remove("hidden", "slide-out");
                this.resultsContainer.classList.add("slide-in");
                this.detailsContainer.classList.add("slide-out");
                this.counterResults.classList.remove("hidden");
                this.divider.classList.remove("hidden");
                setTimeout(() => {
                    this.detailsContainer.classList.add("hidden");
                    this.detailsContainer.classList.remove("slide-in", "slide-out");
                }, 300);
            });
        }, 300);
    }

    // FUNZIONE Da SUBAGENZIA A AGENZIA PADRE
    agencyParentInfo(codiceudvparent) {
        if (codiceudvparent != null) {
            const resultAgency = this.agencyList.find(agency => agency.agencyDTO.codiceudv == codiceudvparent);
            console.log("resultAgency", resultAgency);
            return `<p>${resultAgency.agencyDTO.name}</p>
                        <p>${resultAgency.agencyDTO.address}</p>`
        }

    }

    // FUNZIONE Da AGENZIA A SUBAGENZIA
    agencyAffiliatedInfo(codiceAgency) {
        if (codiceAgency != null) {
            const resultAgenciesAffiliated = this.agencyList.filter(agency => agency.agencyDTO.codiceudvparent == codiceAgency);

            return resultAgenciesAffiliated
                .map(subAgency => `<div class="agency-subagency">
                <p>${subAgency.agencyDTO.name}</p>
                <p>${subAgency.agencyDTO.address}</p></div>
              `).join("");
        }
    }


    formatDate(data) {
        const date = new Date(data);
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`
    }

    clearMarkers() {
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];
        this.markerCluster?.clearMarkers();
    }

    handleNoResults() {
        const currentZoom = this.map.getZoom();
        if (currentZoom > 3) {
            this.map.setZoom(currentZoom - 1);
            this.fetchNearbyAgencies();
        } else {
            this.resultsContainer.innerHTML = `<div class="no-results">Nessuna agenzia trovata, anche dopo zoom-out.</div>`;
        }
    }


}

export default MapComponent;
